<template>
      <v-data-table
        dense
        :headers="headers"
        :items="boxes"
        :loading-text="$t('settings.box.boxLoadingText')"
        :no-data-text="$t('settings.box.noBox')"
        mobile-breakpoint="768"
        item-key="id"
        :loading="loading"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-card-title class="pl-0">{{ $t('settings.boxes') }}</v-card-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              outlined
              @click="$emit('open-new')"
              :disabled="loading"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.length="{ item }">
          {{ item.length }} {{ item.dimensionUnit }}
        </template>

        <template v-slot:item.width="{ item }">
          {{ item.width }} {{ item.dimensionUnit }}
        </template>

        <template v-slot:item.height="{ item }">
          {{ item.height }} {{ item.dimensionUnit }}
        </template>

        <template v-slot:item.emptyWeight="{ item }">
          {{ item.emptyWeight ? item.emptyWeight +  item.weightUnit : '-'}}
        </template>

        <template v-slot:item.maxWeight="{ item }">
          {{ item.maxWeight ? item.maxWeight +  item.maxWeightUnit : '-'}}
        </template>

        <template v-slot:item.activate="{ item }">
          <v-switch v-model="item.activate" :disabled="loading"></v-switch>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <v-btn icon @click="$emit('edit', item)" :disabled="loading">
              <v-icon color="primary">mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('delete', item)" :disabled="loading">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
</template>

<script>
export default {
  name: 'BoxSettingsTable',
  props: {
    boxes: Array,
    loading: Boolean,
  },
  computed: {
    headers() {
      return [
        { text: this.$t('settings.box.name'), value: 'name' },
        { text: this.$t('settings.box.length'), value: 'length' },
        { text: this.$t('settings.box.width'), value: 'width' },
        { text: this.$t('settings.box.height'), value: 'height' },
        { text: this.$t('settings.box.weight'), value: 'emptyWeight' },
        { text: this.$t('settings.box.maxWeight'), value: 'maxWeight' },
        { text: this.$t('settings.active'), value: 'activate' },
        { text: '', value: 'actions', sortable: false },
      ]
    },
  }
}
</script>
